import { useTranslation } from 'react-i18next';
import { prettyMoney } from '@scramble/utils';
import { useBrandSelectionStatus } from '@/pages/InvestingPage/hooks/useBrandSelectionStatus';
import s from './index.module.scss';

export const BrandSelectionInfo = ({ totalAllocated, step }) => {
  const { t } = useTranslation();
  const {
    hasData,
    selectedBrandCount,
    excludedBrands,
    fee,
    feeAmount,
    confirmedFeeAmount,
  } = useBrandSelectionStatus({ step, totalAllocated });

  if (!hasData || excludedBrands === 0) return null;

  return (
    <div className={s.wrapper}>
      <div className={s.title}>{t('investing:brands_invested.header')}</div>
      <div className={s.block}>
        <div className={s.row}>
          <div className={s.row_left}>
            {t('investing:brands_invested.included_brands')}
          </div>
          <div className={s.row_right}>
            <span className="f-500">{selectedBrandCount}</span>
          </div>
        </div>
        <div className={s.row}>
          <div className={s.row_left}>
            {t('investing:brands_invested.excluded_brands')}
          </div>
          <div className={s.row_right}>
            <span className="f-500">{excludedBrands}</span>
          </div>
        </div>
        <div className={s.row}>
          <div className={s.row_left}>
            <span className="f-500">
              {t('investing:brands_invested.brand_exclusion_fee')}
            </span>
            <span className={s.desc}>
              {t('investing:brands_invested.deducted_after_round')}
            </span>
          </div>
          <div className={s.row_right}>
            <span
              className="f-500"
              style={{
                color: 'var(--Text-Danger-Primary-Base, #D23030)',
              }}
            >
              {`-${prettyMoney(step === 'confirmed' ? confirmedFeeAmount : feeAmount)}`}
            </span>
            <span className={s.desc}>{`${fee}%`}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
